import { Button } from '@mui/material';
import type { MouseEvent, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  MapTimelineLayersDetails,
  TimelineLayerId,
} from 'features/mapping/mapping.constants';
import { TimelinePlayIcon } from './TimelinePlayIcon';

type TimelinePlayButtonProps = {
  layerId: TimelineLayerId;
  onClick: () => void;
};

const stopPropagation = (event: SyntheticEvent): void => {
  event.stopPropagation();
};

export const TimelinePlayButton = ({
  layerId,
  onClick,
}: TimelinePlayButtonProps): JSX.Element => {
  const { t } = useTranslation();

  const handleClick = (event: MouseEvent): void => {
    event.stopPropagation();
    onClick();
  };

  return (
    <Button
      color="neutral"
      size="small"
      startIcon={<TimelinePlayIcon />}
      onClick={handleClick}
      onMouseDown={stopPropagation}
      onTouchStart={stopPropagation}
      aria-label={t('map.timeline.playLayerTimeline', {
        layer: t(MapTimelineLayersDetails[layerId].titleKey),
      })}
      sx={{
        px: 1,
        borderRadius: '8px',
        typography: 'body2',
        fontWeight: 600,
        '& .MuiButton-startIcon': {
          ml: 0,
          mr: 0.5,
          '& svg': { fontSize: 24 },
        },
      }}
    >
      {t('map.timeline.play')}
    </Button>
  );
};
